import SlsPicRegraClient from '@/api/Cadastros/ApoioVendas/sls-pic-regra.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSPicRegraService {
  constructor() {
    this.client = new SlsPicRegraClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os tipo pedido');
    }
  }

  async store(data) {
    try {
      const response = await this.client.store(data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Tipo Pedido');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Tipo Pedido');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Tipo Pedido');
    }
  }
}
